//removeIf(production)
import CupsOption from "../../enums/cups-option";
import FloatWithTwoDecimals from "./float-with-two-decimals";
//endRemoveIf(production)

class ClaroluzCupsData {
    cups: string;
    price: FloatWithTwoDecimals;
    type?: CupsOption;
    options?: {
        powerP1?: number,
        powerP2?: number,
        powerP3?: number,
        month?: number
    };
    
    constructor({ cups, price }: { cups: string; price: FloatWithTwoDecimals; }) {
        this.cups = cups;
        this.price = price;
    }

    public setOptions({ type, powerP1, powerP2, powerP3, month }: { type: CupsOption; powerP1?: number; powerP2?: number; powerP3?: number; month?: number; }) {
        this.type = type;

        if (this.type === CupsOption.Power) {
            this.options = {
                powerP1: powerP1,
                powerP2: powerP2,
                powerP3: powerP3
            };
        } else if (this.type === CupsOption.Month) {
            this.options = {
                month: month
            };
        }
    }
}

//removeIf(production)
export default ClaroluzCupsData;
//endRemoveIf(production)